import { H2 } from 'UIComponents/elements/headings';
import styled from 'academy-common-lib/utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
import VideoPlayer from '../../../components/VideoPlayer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VideoSection = styled.section.withConfig({
  displayName: "PublicPageVideoSection__VideoSection",
  componentId: "sc-1e255hu-0"
})(["padding:32px 0;"]);
const PublicPageVideoSection = ({
  creatorHubId,
  videoId
}) => {
  if (!creatorHubId) {
    return null;
  }
  return /*#__PURE__*/_jsxs(VideoSection, {
    children: [/*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.previewVideo.watchPreview"
      })
    }), /*#__PURE__*/_jsx(VideoPlayer, {
      creatorHubId: creatorHubId,
      videoId: videoId
    })]
  });
};
export default PublicPageVideoSection;